import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"

const 製造検査成績書 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { manufactureInspectionCertificate: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField isShow={shouldShow} legend="製造検査成績書" helpURL={HELP_LINKS.製造検査成績書}>
      <RadioGroup
        name={FIELD_NAMES.製造検査成績書}
        selectedValue={values.manufactureInspectionCertificate}
        onChange={handlers.radio}
      >
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT.製造検査成績書.発行あり.value}>発行あり</Radio>
          <Radio value={ESTIMATE_CONSTANT.製造検査成績書.発行なし.value}>発行なし</Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.manufactureInspectionCertificate} />
    </OneClickField>
  )
}

export default 製造検査成績書
